import gql from 'graphql-tag'

export const STAFF_CHANGE_PASSWORD = gql`
  mutation STAFF_CHANGE_PASSWORD($oldPassword: String!, $newPassword: String!) {
    staffChangePassword(oldPassword: $oldPassword, newPassword: $newPassword)
  }
`
